import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _templateTypes = [];

const EmailTemplateTypeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _templateTypes.filter(function(e) { return e !== undefined; });
    },

    getFor: function(item) {
        // todo: filter template types per item
        // -- add field to template type that links it to entities
        if (!item) { return []; }
        const map = ({id, internalName, name}) => ({ id, internalName, name });
        switch (item) {
            case 'event':
                return _templateTypes
                    // .filter((t) => t !== undefined && t.internalName.substr(0, 6) === 'event_')
                    .filter((t) => t !== undefined && (t.internalName === 'event_booking_cancelled' || t.internalName === 'event_did_not_attend'))
                    .map(map);
            default:
                return [];
        }
    },
    add: function(entity) {
        let index = _templateTypes.findIndex(function(e) { return e !== undefined && e.id == entity.id;});
        if (0 <= index) {
            _templateTypes[index] = entity;
        } else {
            _templateTypes.push(entity);
        }
    }
});

EmailTemplateTypeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.EMAIL_TEMPLATE_TYPE_LIST:
            action.data.forEach(EmailTemplateTypeStore.add);
            EmailTemplateTypeStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_TYPE_LIST_ERROR:
            EmailTemplateTypeStore.emitChange();
            break;

        default:
            break;

    }

});

export default EmailTemplateTypeStore;


